import ChangeEntry from "components/change-entry/ChangeEntry";
import { ChangeType } from "enums";
import manager from "managers/app";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import { ViewLatestChangesProps } from "views/changelog/types";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		appVersion: state.appVersion,
	};
};

class LatestChanges extends Component<ViewLatestChangesProps> {
	render():JSX.Element{
		return (
			<div className="recent-changes">
				<h2>{t.t("Latest Changes")}</h2>
				<h3>{`${t.t("Version")} ${this.props.appVersion}`}</h3>
				<ul>
					<ChangeEntry type={ChangeType.NEW} entry="Added Phantom Relic" />
					<ChangeEntry type={ChangeType.NEW} entry="Added Resplendent Relic" />
					<ChangeEntry type={ChangeType.NEW} entry="Added Cosmic Relic" />
					<ChangeEntry type={ChangeType.NEW} entry="Ability to manually add characters" />
					<ChangeEntry type={ChangeType.FIX} entry="General fixes" />
				</ul>
			</div>
		);
	}

	componentDidMount = () => {
		manager.view.changeComplete();
	}
}
export default connect(mapStateToProps)(LatestChanges);
